module.exports = __webpack_public_path__ + "img/thumb_26.bce91545.jpg";